import _objectSpread from "D:\\office-work\\skp 14-4-25\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "D:\\office-work\\skp 14-4-25\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import Collapse from './Collapse';
import AccordionContext, { isAccordionItemSelected } from './AccordionContext';
import { jsx as _jsx } from "react/jsx-runtime";
var AccordionCollapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      eventKey = _ref.eventKey,
      props = _objectWithoutProperties(_ref, ["as", "bsPrefix", "className", "children", "eventKey"]);

  var _useContext = useContext(AccordionContext),
      activeEventKey = _useContext.activeEventKey;

  bsPrefix = useBootstrapPrefix(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/_jsx(Collapse, _objectSpread({
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey)
  }, props, {
    className: classNames(className, bsPrefix),
    children: /*#__PURE__*/_jsx(Component, {
      children: React.Children.only(children)
    })
  }));
});
AccordionCollapse.displayName = 'AccordionCollapse';
export default AccordionCollapse;